module.exports = __webpack_public_path__ + "img/inventory.9671c2f3.svg";